import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import GoogleSignIn from '../GoogleSignIn'
import { GoogleButton } from '@olxbr/ds-core'
import { isLoginScrollEnabled } from '../../../util/experiments'

const Wrapper = styled.div`
  position: relative;
  display: inline-flex;
  cursor: pointer;
`

const NativeOverlay = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  opacity: 0.01;
  overflow: hidden;
  z-index: 1;

  & > div > div {
    transform: scale(4);
    transform-origin: top left;
  }
`

const googleSignInProps = ({
  onSubmit,
  onError,
  onCancel,
  onUserLoggedIn,
  lurker,
  tracker,
  onPhoneNotValidatedError,
  onChallengePinCodeCall,
  sessionTokens,
  onAccountNotValidated,
  onAccountMustValidate,
  abTests,
  modalMode,
  onAccountSocialLoginTyping,
  onAccountCompleteData,
}) => ({
  onCancel,
  onError,
  onSubmit,
  onSuccess: onUserLoggedIn,
  lurker,
  tracker,
  onPhoneNotValidatedError,
  onChallengePinCodeCall,
  sessionTokens,
  onAccountNotValidated,
  onAccountMustValidate,
  abTests,
  modalMode,
  onAccountSocialLoginTyping,
  onAccountCompleteData,
})

const GoogleIconButton = props => {
  if (isLoginScrollEnabled(props.abTests)) {
    return (
      <Wrapper>
        <GoogleButton size="medium" aria-label="Login Google" tabIndex={-1}>
          Google
        </GoogleButton>
        <NativeOverlay>
          <GoogleSignIn {...googleSignInProps(props)} />
        </NativeOverlay>
      </Wrapper>
    )
  }

  return <GoogleSignIn {...googleSignInProps(props)} />
}

GoogleIconButton.propTypes = {
  onCancel: PropTypes.func,
  onError: PropTypes.func,
  onSubmit: PropTypes.func,
  onUserLoggedIn: PropTypes.func,
  lurker: PropTypes.object, // eslint-disable-line react/forbid-prop-types
  tracker: PropTypes.object, // eslint-disable-line react/forbid-prop-types
  onPhoneNotValidatedError: PropTypes.func,
  onChallengePinCodeCall: PropTypes.func,
  sessionTokens: PropTypes.object, // eslint-disable-line react/forbid-prop-types
  onAccountNotValidated: PropTypes.func,
  onAccountMustValidate: PropTypes.func,
  abTests: PropTypes.string,
  modalMode: PropTypes.bool,
  onAccountSocialLoginTyping: PropTypes.func,
  onAccountCompleteData: PropTypes.func,
}

export { GoogleIconButton }
